import {
  input,
  computed,
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { IProjectsListingVM } from '@core/state/entities/project/project-summary.viewmodel';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { GridModule } from '@ngbracket/ngx-layout/grid';
import { MatListModule } from '@angular/material/list';
import { NewlinePipe } from '../../shared/pipes/newline.pipe';
export interface IProjectList {
  subheading?: string;
  projects: IProjectsListingVM[];
}
export const hasSections = (
  projectLists: IProjectList[] | IProjectsListingVM[]
): projectLists is IProjectList[] => {
  return !!((projectLists as IProjectList[])?.[0]?.subheading ?? false);
};
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatListModule,
    GridModule,
    RouterLink,
    MatTooltipModule,
    MatIconModule,
    NgClass,
    NewlinePipe,
  ],
})
export class ListComponent implements OnInit {
  readonly projectLists = input<IProjectList[] | IProjectsListingVM[]>([]);

  readonly sections = computed<IProjectList[]>(() => {
    const inputList = this.projectLists();
    return hasSections(inputList)
      ? inputList
      : [
          {
            projects: inputList as IProjectsListingVM[],
          },
        ];
  });

  @Output()
  openProject = new EventEmitter<string>();

  ngOnInit() {}

  trackProject(index: number, project: IProjectsListingVM) {
    return project.id;
  }
}
